import React, { useEffect, useState } from 'react'
import { useLocation, useHistory } from 'react-router'
import { serverConn } from '../../../API/apiRequest'
import { Button } from '../../../components/Button/Button'
import { Logo } from '../../../components/Logo/Logo'
import { NavText } from '../../../components/NavElements'
import { Picker } from '../../../components/Picker/Picker'
import TextField from '../../../components/TextField/TextField'
import classes from './RegisterEmployer.module.css'
import validator from 'validator'
import ReactGA from 'react-ga'

interface Props {

}


export const RegisterEmployer: React.FC<Props> = () => {
    const [placeName, setPlaceName] = useState<string>('')
    const [placeTypeOptions, setPlaceTypeOptions] = useState<[{label: string, value: string}] | []>([])
    const [placeType, setPlaceType] = useState<{label: string, value: string} | null>(null)
    const [name, setName] = useState<string>('')
    const [email, setEmail] = useState<string>('')
    const [phone, setPhone] = useState<string>('')
    const [password, setPassword] = useState<string>('')
    const [err, setErr] = useState<string>('')
    const [loadingPlaceType, setLoadingPlaceType] = useState<boolean>(true)

    const { pathname } = useLocation()
    const history = useHistory()

    useEffect(()=>{
        async function getPlaceType(){
            try{
                let result = await serverConn.get('/config/placetype')
                setPlaceTypeOptions(result.data.placeTypes)
                setLoadingPlaceType(false)
            }catch(e){
                console.log(e)
            }
        }
        getPlaceType()
        window.scrollTo(0, 0)
        ReactGA.pageview(window.location.pathname)
    },[pathname])


    const onNext = ()=>{
       /*  to='/employer/step' */
        if(name.trim() === ''|| name.length < 5 || name.length >= 30) return setErr('الإسم غير صحيح من فضلك قم بكتابة الإسم ثنائي')
        if(name.split(' ').length < 2) return setErr('الإسم غير صحيح من فضلك قم بكتابة الإسم ثنائي')
        if(!validator.isEmail(email)) return setErr('البريد الإلكتروني غير صحيح')
        if(phone.trim().length < 10) return setErr('رقم الهاتف غير صحيح')
        if(password.trim() === '') return setErr('من فضلك ادخل كلمة السر')
        if(placeName.trim() === '') return setErr('اسم المكان غير صحيح')
        if(!placeType) return setErr('نوع المكان غير صحيح')

        return history.push('/employer/step', {name, placeName, password, phone, email, placeType})
    }

    return (
        <div className={classes.container}>
            <div className={classes.darker}>
                <NavText to='/'><Logo /></NavText>
                <div className={classes.headText}>
                    <p className={classes.mainText}> التسجيل للشركات واصحاب الأعمال</p>
                    <p className={classes.text}>وظائف خالية في جميع المجالات فقط في مدينة السادات</p>
                </div>
                <div className={classes.formContainer}>
                    <TextField 
                        containerStyle={{margin: 5}} 
                        bgColor='#1D252D' 
                        iconName={'FiHome'} 
                        placeholder='اسم مكان العمل'
                        width={200}
                        value={placeName}
                        handleChange={({target})=>setPlaceName(target.value)}
                
                    />
                    <Picker 
                        value={placeType}
                        onChange={(value)=>{setPlaceType(value); setErr('')}}
                        options={placeTypeOptions} 
                        placeholder='نوع مكان العمل'
                        loading={loadingPlaceType}
                    />
                    <TextField 
                        containerStyle={{margin: 5}} 
                        bgColor='#1D252D' 
                        iconName={'FiUser'} 
                        placeholder='الإسم'
                        width={200}
                        value={name}
                        handleChange={({target})=>setName(target.value)}
                    />
                    <TextField 
                        containerStyle={{margin: 5}} 
                        bgColor='#1D252D' 
                        iconName={'FiMail'} 
                        placeholder='البريد الإلكتروني'
                        width={200}
                        value={email}
                        handleChange={({target})=>setEmail(target.value)}
                    />
                    <TextField 
                        containerStyle={{margin: 5}} 
                        bgColor='#1D252D' 
                        iconName={'FiPhone'} 
                        placeholder='رقم الهاتف'
                        width={200}
                        value={phone}
                        handleChange={({target})=>setPhone(target.value)}

                    />
                    <TextField 
                        containerStyle={{margin: 5}} 
                        bgColor='#1D252D' 
                        iconName={'FiLock'} 
                        placeholder='كلمة المرور'
                        width={200}
                        type='password'
                        value={password}
                        handleChange={({target})=>setPassword(target.value)}
                    />
                </div>
                <div style={{
                    height: 30,
                    marginTop: 10}}>
                    {err && <p style={{color: 'rgb(255, 116, 116)', textAlign: 'center', margin: 0, padding: 0}}>
                        {err}
                    </p>}
                </div>
                <Button color='#5A8D59' style={{marginTop: 10}} onPress={onNext}>تسجيل</Button>
                <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', width: 300, justifyContent: 'space-around', marginTop: 30}}>
                    <NavText to='/login' style={{fontSize: 15, fontWeight: 200}}>تسجيل دخول</NavText>
                    <p style={{color: 'white', fontWeight: 200,  paddingRight: 0}}>|</p>
                    <NavText to='/' style={{fontSize: 15, fontWeight: 200}}>الرئيسية</NavText>
                </div>
            </div>
        </div>
    )
}